import { Plugin } from '@nuxt/types';
import externalVisitTrackerJs from '@bukalapak/external-visit-tracker-js';
import Cookies from 'js-cookie';
import { generateBrowserID, getPlatform } from '~/utils/platform';

const ExternalVisitTrackerJs: Plugin = ({ app, store, route }) => {
  const userId = store.getters.getUserId36;
  const axios = app.$axios;
  const clientId = generateBrowserID();
  const platform = getPlatform();
  const { identity } = app.$credentials;
  const cookieDomain = process.env.WEB_DOMAIN;
  const action = route.name === 'authorize_page' ? 'login' : 'visit';
  const cookieLoginName = 'track_login';

  externalVisitTrackerJs.run({
    action,
    cookieDomain,
    axios,
    userId,
    clientId,
    platform,
    identity,
    afterSend: () => {
      if (Cookies.get(cookieLoginName)) {
        Cookies.remove(cookieLoginName, { path: '/', domain: cookieDomain });
      }
    },
  });
};

export default ExternalVisitTrackerJs;
